import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';

export function NotFound() {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-screen items-center justify-center bg-[color:var(--color-bg)] p-6">
      <Card className="max-w-md text-center">
        <CardHeader>
          <CardTitle>{t('errors.notFoundTitle')}</CardTitle>
          <CardDescription>{t('errors.notFoundBody')}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild>
            <Link to="/dashboard">{t('errors.back')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
